module.exports = require('./helpers/bundle-url').getBundleURL('cgEes') + "logo.7718c6df.svg";